import { render, staticRenderFns } from "./ArrowDownGP.vue?vue&type=template&id=2a98b302&scoped=true"
import script from "./ArrowDownGP.vue?vue&type=script&lang=js"
export * from "./ArrowDownGP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a98b302",
  null
  
)

export default component.exports